import { STATUS } from "@/constant/statusConstants";

export const TermInitialValues = (showData) => ({
  code: showData?.data?.code || "",
  name: showData?.data?.name || "",
  status: showData?.data?.status || STATUS.INACTIVE,
});
